import { render, staticRenderFns } from "./AdminAcademicCategoriesEdit.html?vue&type=template&id=5c719460&scoped=true&"
import script from "./AdminAcademicCategoriesEdit.vue?vue&type=script&lang=js&"
export * from "./AdminAcademicCategoriesEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminAcademicCategoriesEdit.scss?vue&type=style&index=0&id=5c719460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c719460",
  null
  
)

export default component.exports